/* eslint-disable react/no-array-index-key */
import React from 'react';
import { albumArtDefault } from '../../utils/helpers';

const FeaturedAlbumArt = ({ albumArts, roundedCorners }) => {
  if (!albumArts || albumArts.length < 1) {
    const borderRadius = roundedCorners ? 'border-10' : '';
    return (
      <div className={`w-100 h-100 ${borderRadius}`}>
        <img
          className={`d-inline w-100 h-100 ${borderRadius}`}
          src={albumArtDefault}
          alt=""
        />
      </div>
    );
  }

  const borderRadius = roundedCorners ? 'border-10' : '';
  const radiusMap = {
    0: { borderTopLeftRadius: '10px' },
    1: { borderTopRightRadius: '10px' },
    2: { borderBottomLeftRadius: '10px' },
    3: { borderBottomRightRadius: '10px' },
  };

  return (
    <>
      {albumArts.length < 4 ? (
        <div className={`w-100 h-100 ${borderRadius}`}>
          <img
            className={`d-inline w-100 h-100 ${borderRadius}`}
            src={albumArts[0] || albumArtDefault}
            alt=""
          />
        </div>
      ) : (
        <div className="collection__featured-album-art">
          {albumArts.map((img, i) => (
            <img
              src={img || albumArtDefault}
              key={i}
              alt="album"
              style={roundedCorners ? radiusMap[i] : {}}
            />
          ))}
        </div>
      )}
    </>
  );
};

export default FeaturedAlbumArt;
